import Vue from 'vue'
import Router from 'vue-router'
import appRoutes from '@/modules/app/routes/appRoutes'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    ...appRoutes
  ]
})

export default router
